import Vue from 'vue';
import VueI18n from 'vue-i18n';

import de from './locales/de.json';
import en from './locales/en.json';

Vue.use(VueI18n);

export default new VueI18n({
  locale: window.document.getElementsByTagName('html').item(0).lang || 'de', // set locale
  silentTranslationWarn: true,
  messages: { de, en }
});
